import { render, staticRenderFns } from "./noRecordTemplate.vue?vue&type=template&id=64c6fa1a&scoped=true"
import script from "./noRecordTemplate.vue?vue&type=script&lang=js"
export * from "./noRecordTemplate.vue?vue&type=script&lang=js"
import style0 from "./noRecordTemplate.vue?vue&type=style&index=0&id=64c6fa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6fa1a",
  null
  
)

export default component.exports